import { MainLayout } from '@/components/Layouts/MainLayout/MainLayout';
import RedirectToAccountOverview from '@/features/account_overview/components/RedirectToAccountOverview';

const RootPage = () => {
  return (
    <MainLayout>
      <RedirectToAccountOverview />
    </MainLayout>
  );
};

export default RootPage;
